module.exports = __webpack_public_path__ + "img/headshot.6fb720a6.jpg";